import React, { CSSProperties } from 'react';
/* eslint-disable max-len */

const CircleSpinner = (): JSX.Element => {
  // Define animation keyframes in a style tag with anti-aliasing fixes
  const spinKeyframes = `
    @keyframes spin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
    
    /* Improve SVG rendering */
    svg {
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-rendering: optimizeLegibility;
    }
  `;

  // SVG styles with improved rendering quality
  const svgStyle: CSSProperties = {
    animation: 'spin 1.5s linear infinite',
    transformOrigin: 'center',
    display: 'block',
    willChange: 'transform', // Optimize for animation
  };

  // Path style with crisp rendering properties
  const pathStyle: CSSProperties = {
    fill: 'none',
    // stroke: '#3774E7',
    stroke: 'inherit',
    strokeWidth: 4,
  };

  return (
    <>
      <style>{spinKeyframes}</style>
      <svg
        style={svgStyle}
        viewBox="0 0 35 35"
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        preserveAspectRatio="xMidYMid meet"
      >
        <path
          style={pathStyle}
          d="M2 17.3928C2 25.894 8.8916 32.7856 17.3928 32.7856C25.894 32.7856 32.7856 25.894 32.7856 17.3928C32.7856 8.8916 25.894 2 17.3928 2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export default CircleSpinner;

